import { createContext, useContext } from 'react';
import type { Editor } from '@tiptap/react';

interface IEditorContext {
   editor: Editor;
   preset: string;
}

const editorContextDefaults: IEditorContext = {
   // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'Editor'.
   editor: null,
   preset: '',
};

export const EditorContext = createContext<IEditorContext>(editorContextDefaults);

export const useEditorContext = () => useContext(EditorContext);
